/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "app",
  initialState: {
    menuTitle: "",
    loginFromCart: false,
    onlineStatus: navigator.onLine, // Add initial online status
  },
  reducers: {
    setMenuTitle(state, action) {
      state.menuTitle = action.payload;
    },
    setLoginFromCart(state, action) {
      state.loginFromCart = action.payload;
    },
    setOnlineStatus(state, action) {
      state.onlineStatus = action.payload;
    },
  },
});

export const { setMenuTitle, setLoginFromCart, setOnlineStatus } =
  appSlice.actions;
export default appSlice.reducer;
